<template>
  <el-dialog title="网页" :visible.sync="dialogVisible" width="70%" center>
    <el-form ref="formRef" :model="form" label-width="200px" size="small" :rules="rules">
      <el-form-item label="链接地址：" prop="link">
        <el-input
          type="text"
          placeholder="请输入http://或https://开头的链接"
          class="width_medium"
          v-model.trim="form.link"
        ></el-input>
      </el-form-item>
      <el-form-item label="网页标题：" prop="title">
        <el-input
          type="text"
          placeholder="请输入网页标题"
          class="width_medium"
          show-word-limit
          maxlength="20"
          v-model.trim="form.title"
        ></el-input>
      </el-form-item>
      <el-form-item label="描述：" prop="description">
        <el-input
          type="text"
          placeholder="请输入描述"
          show-word-limit
          maxlength="128"
          class="width_medium"
          v-model.trim="form.description"
        ></el-input>
      </el-form-item>
      <el-form-item label="封面：" prop="cover">
        <el-upload
          accept="image/*"
          :action="commonUrl.uploadImg"
          :headers="commonUrl.headers"
          :data="picMedia"
          :multiple="false"
          :on-success="handlePicSuccess"
          :before-upload="handleBeforeUpload"
          :show-file-list="false"
          class="upload-btn"
        >
          <div class="upload-inner">
            <img v-if="form.cover" :src="form.cover" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <span class="upload-tip">建议JPG/PNG格式，图片小于2MB</span>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="handleConfirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import commonApi from '@/api/common'

export default {
  data() {
    const validateLink = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入链接地址'))
      } else if (!/^https?:\/\//i.test(value)) {
        callback(new Error('请输入http://或https://开头的链接'))
      } else {
        callback()
      }
    }
    return {
      commonUrl: commonApi.commonUrl,
      picMedia: {
        mediaJson: JSON.stringify({
          appType: 3,
          type: 1,
          picContent: {
            suffix: 'png'
          }
        })
      },
      rules: {
        link: [
          { required: true, message: '请输入链接地址', trigger: 'blur' },
          { validator: validateLink, trigger: 'blur' }
        ],
        title: [{ required: true, message: '请输入网页标题', trigger: 'blur' }]
      },
      dialogVisible: false,
      form: { link: '', title: '', description: '', cover: '' } // 表单数据
    }
  },
  methods: {
    close() {
      this.form.link = ''
      this.form.title = ''
      this.form.description = ''
      this.form.cover = ''
      this.$refs.formRef.resetFields() // 重置表单
      this.dialogVisible = false
    },
    open() {
      this.dialogVisible = true
    },
    handleConfirm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.$emit('onConfirm', JSON.parse(JSON.stringify(this.form)))
        this.close()
      })
    },
    handleBeforeUpload(file) {
      const { size } = file
      if (size > 2 * 1024 * 1024) {
        this.$message.error('图片大小不能超过2MB')
        return false
      }
      console.log(file)
    },
    handlePicSuccess(res) {
      console.log(res, 'res')
      if (res.code.value === 2000000) {
        this.form.cover = this.commonUrl.imgPrefix + res.data.url
      } else {
        this.$message.error(res.message)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.upload-inner {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
}
.avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  width: 50px;
  height: 50px;
  font-size: 50px;
  border: 1px dashed #ddd;
  box-sizing: border-box;
}
.upload-tip {
  margin-top: 10px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/views/operateManage/wechat_push/linkForm.vue